import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'jellyfish',
      d: 'M-1,-4h2v0.5h-2zM-2,-3.5h1.5v0.5h-1.5zM0,-3.5h1.5v0.5h-1.5zM-2,-3h4v0.5h-4zM-2.5,-2.5h4.5v0.5h-4.5zM-2.5,-2h5v0.5h-5zM-2,-1.5h4v0.5h-4zM-2,-1h0.5v0.5h-0.5zM-0.5,-1h1.5v0.5h-1.5zM1.5,-1h0.5v0.5h-0.5zM-2,-0.5h1v0.5h-1zM-0.5,-0.5h2.5v0.5h-2.5zM-1.5,0h0.5v0.5h-0.5zM-0.5,0h0.5v0.5h-0.5zM0.5,0h1.5v0.5h-1.5zM-2,0.5h1v0.5h-1zM-0.5,0.5h1.5v0.5h-1.5z',
    },
    { paint: 'sail', d: 'M-0.5,-3.5h0.5v0.5h-0.5z' },
  ],
  pixels: 68,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
